//TODO: implementation will be used in conjunction with 
//API for otp entry and confirming if an account is locked or nots
const STORAGE_KEY = 'dash_otp_attempts';
const MAX_OTP_ATTEMPTS = 5;
// 5 minutes (total minutes * minute in ms)
const LOCKOUT_DURATION_MS = 5 * 60 * 1000;

interface OtpAttemptRecord {
  attempts: number;
  lockedUntil: number | null;
}

function emptyRecord(): OtpAttemptRecord {
  return { attempts: 0, lockedUntil: null };
}

function getRecord(): OtpAttemptRecord {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyRecord();

    const record = JSON.parse(raw) as OtpAttemptRecord;

    // Expired lockout — wipe attempts so the user gets a fresh window
    if (record.lockedUntil !== null && Date.now() >= record.lockedUntil) {
      localStorage.removeItem(STORAGE_KEY);
      return emptyRecord();
    }

    return record;
  } catch {
    return emptyRecord();
  }
}

export function isOtpLocked(): boolean {
  const { lockedUntil } = getRecord();
  return lockedUntil !== null && Date.now() < lockedUntil;
}

export function recordOtpFailure(): { locked: boolean; remaining: number } {
  const record = getRecord();
  const attempts = record.attempts + 1;
  const locked = attempts >= MAX_OTP_ATTEMPTS;

  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    attempts,
    lockedUntil: locked ? Date.now() + LOCKOUT_DURATION_MS : null
  }));

  return { locked, remaining: MAX_OTP_ATTEMPTS - attempts };
}

export function clearOtpAttempts(): void {
  localStorage.removeItem(STORAGE_KEY);
}